/**
 * The brand seam for the NPS feature — the survey itself lives in the
 * brandless @repo/nps package; this directory is the app wiring that names
 * brands and resolves the config/eligibility the package consumes.
 *
 * Client-safe: no server-only imports. The server-side eligibility seam lives
 * in `./eligibility` (imported only by actions.ts).
 */
import { byBrand } from "@repo/tailwind-config/brand";
import type { NpsBrandConfig } from "@repo/nps";
import { kinsaNpsConfig } from "./kinsa";
import { owletNpsConfig } from "./owlet";

export const npsBrandConfig: NpsBrandConfig = byBrand({
  kinsa: kinsaNpsConfig,
  owlet: owletNpsConfig,
});
